'use client';

import {useMemo} from 'react';
import {useClpCourse} from '../../../context/clp-course-provider.react-component';
import type {PreviewableLecture} from '@/types/lecture';

/**
 * Parses the course curriculum and returns lectures where isPreviewable is true.
 * Returns display metadata only — no asset data is fetched here.
 * durationInSeconds is derived directly from the lecture curriculum data.
 */
export function usePreviewableLectures(): PreviewableLecture[] {
    const course = useClpCourse();

    return useMemo(() => {
        const sections = course.curriculum?.sections;
        if (!sections) return [];

        return sections
            .flatMap((section) => section.items)
            .filter((item) => 'isPreviewable' in item && item.isPreviewable)
            .map((item) => {
                const lecture = item as {
                    id: string;
                    title: string;
                    durationInSeconds: number;
                    images?: {height100?: string | null};
                };
                return {
                    id: lecture.id,
                    title: lecture.title,
                    durationInSeconds: Number(lecture.durationInSeconds),
                    thumbnail: lecture.images?.height100 ?? null,
                };
            });
    }, [course]);
}
